export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11335.4ed7f577.jpg";